import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WJumpLinksCCD: IClientComponentDefinition = {
  name: 'WJumpLinks',
  load: () => import(/* webpackChunkName: 'WJumpLinks' */ './w-jump-links.component'),
}
